export default [
  {
    path: window.pathApp + '/confirmacao-de-dados/:tipo?',
    name: 'confirmacao.de.dados',
    component: () => import('@/components/ConfirmacaoDeDados'),
    meta: {
      login: true,
      avisoCarrinho: false,
      title: "Confirmação de Dados",
    }
  },
]



// WEBPACK FOOTER //
// ./src/router/routes/confirmacao_de_dados.js